import React from 'react';

import { Chip } from '@mui/material';

interface Props {
  employee: App.BusinessEmployee;
}

type InviteEmailStatusType = 'Accepted' | 'Pending' | 'Expired' | 'Not sent';

export function getInviteEmailStatus(employee: App.BusinessEmployee): InviteEmailStatusType {
  if (employee.status === 'ACTIVATED' || employee.status === 'DEACTIVATED') {
    return 'Accepted';
  }
  if (!employee.invitedAt) {
    return 'Not sent';
  }
  if (employee.status === 'EXPIRED') {
    return 'Expired';
  }

  return 'Pending';
}

export default function InviteEmailStatus({ employee }: Props) {
  const status = getInviteEmailStatus(employee);

  const chipConfig: Record<InviteEmailStatusType, { color: 'success' | 'warning' | 'default'; label: string }> = {
    Accepted: { color: 'success', label: 'Accepted' },
    Pending: { color: 'warning', label: 'Pending' },
    Expired: { color: 'default', label: 'Expired' },
    'Not sent': { color: 'default', label: 'Not sent' },
  };

  const config = chipConfig[status];

  return <Chip color={config.color} label={config.label} />;
}
